export const PHONE_CODES = [
  { value: '+1-CA', label: '🇨🇦 +1' },
  { value: '+1-US', label: '🇺🇸 +1' },
  { value: '+1242-BS', label: '🇧🇸 +1242' },
  { value: '+1246-BB', label: '🇧🇧 +1246' },
  { value: '+1264-AI', label: '🇦🇮 +1264' },
  { value: '+1268-AG', label: '🇦🇬 +1268' },
  { value: '+1284-VG', label: '🇻🇬 +1284' },
  { value: '+1340-VI', label: '🇻🇮 +1340' },
  { value: '+1345-KY', label: '🇰🇾 +1345' },
  { value: '+1441-BM', label: '🇧🇲 +1441' },
  { value: '+1473-GD', label: '🇬🇩 +1473' },
  { value: '+1649-TC', label: '🇹🇨 +1649' },
  { value: '+1664-MS', label: '🇲🇸 +1664' },
  { value: '+1670-MP', label: '🇲🇵 +1670' },
  { value: '+1671-GU', label: '🇬🇺 +1671' },
  { value: '+1684-AS', label: '🇦🇸 +1684' },
  { value: '+1721-SX', label: '🇸🇽 +1721' },
  { value: '+1758-LC', label: '🇱🇨 +1758' },
  { value: '+1767-DM', label: '🇩🇲 +1767' },
  { value: '+1784-VC', label: '🇻🇨 +1784' },
  { value: '+1787-PR', label: '🇵🇷 +1787' },
  { value: '+1809-DO', label: '🇩🇴 +1809' },
  { value: '+1868-TT', label: '🇹🇹 +1868' },
  { value: '+1869-KN', label: '🇰🇳 +1869' },
  { value: '+1876-JM', label: '🇯🇲 +1876' },
  { value: '+20-EG', label: '🇪🇬 +20' },
  { value: '+211-SS', label: '🇸🇸 +211' },
  { value: '+212-EH', label: '🇪🇭 +212' },
  { value: '+212-MA', label: '🇲🇦 +212' },
  { value: '+213-DZ', label: '🇩🇿 +213' },
  { value: '+216-TN', label: '🇹🇳 +216' },
  { value: '+218-LY', label: '🇱🇾 +218' },
  { value: '+220-GM', label: '🇬🇲 +220' },
  { value: '+221-SN', label: '🇸🇳 +221' },
  { value: '+222-MR', label: '🇲🇷 +222' },
  { value: '+223-ML', label: '🇲🇱 +223' },
  { value: '+224-GN', label: '🇬🇳 +224' },
  { value: '+225-CI', label: '🇨🇮 +225' },
  { value: '+226-BF', label: '🇧🇫 +226' },
  { value: '+227-NE', label: '🇳🇪 +227' },
  { value: '+228-TG', label: '🇹🇬 +228' },
  { value: '+229-BJ', label: '🇧🇯 +229' },
  { value: '+230-MU', label: '🇲🇺 +230' },
  { value: '+231-LR', label: '🇱🇷 +231' },
  { value: '+232-SL', label: '🇸🇱 +232' },
  { value: '+233-GH', label: '🇬🇭 +233' },
  { value: '+234-NG', label: '🇳🇬 +234' },
  { value: '+235-TD', label: '🇹🇩 +235' },
  { value: '+236-CF', label: '🇨🇫 +236' },
  { value: '+237-CM', label: '🇨🇲 +237' },
  { value: '+238-CV', label: '🇨🇻 +238' },
  { value: '+239-ST', label: '🇸🇹 +239' },
  { value: '+240-GQ', label: '🇬🇶 +240' },
  { value: '+241-GA', label: '🇬🇦 +241' },
  { value: '+242-CG', label: '🇨🇬 +242' },
  { value: '+243-CD', label: '🇨🇩 +243' },
  { value: '+244-AO', label: '🇦🇴 +244' },
  { value: '+245-GW', label: '🇬🇼 +245' },
  { value: '+246-IO', label: '🇮🇴 +246' },
  { value: '+248-SC', label: '🇸🇨 +248' },
  { value: '+249-SD', label: '🇸🇩 +249' },
  { value: '+250-RW', label: '🇷🇼 +250' },
  { value: '+251-ET', label: '🇪🇹 +251' },
  { value: '+252-SO', label: '🇸🇴 +252' },
  { value: '+253-DJ', label: '🇩🇯 +253' },
  { value: '+254-KE', label: '🇰🇪 +254' },
  { value: '+255-TZ', label: '🇹🇿 +255' },
  { value: '+256-UG', label: '🇺🇬 +256' },
  { value: '+257-BI', label: '🇧🇮 +257' },
  { value: '+258-MZ', label: '🇲🇿 +258' },
  { value: '+260-ZM', label: '🇿🇲 +260' },
  { value: '+261-MG', label: '🇲🇬 +261' },
  { value: '+262-RE', label: '🇷🇪 +262' },
  { value: '+262-YT', label: '🇾🇹 +262' },
  { value: '+263-ZW', label: '🇿🇼 +263' },
  { value: '+264-NA', label: '🇳🇦 +264' },
  { value: '+265-MW', label: '🇲🇼 +265' },
  { value: '+266-LS', label: '🇱🇸 +266' },
  { value: '+267-BW', label: '🇧🇼 +267' },
  { value: '+268-SZ', label: '🇸🇿 +268' },
  { value: '+269-KM', label: '🇰🇲 +269' },
  { value: '+27-ZA', label: '🇿🇦 +27' },
  { value: '+290-SH', label: '🇸🇭 +290' },
  { value: '+291-ER', label: '🇪🇷 +291' },
  { value: '+297-AW', label: '🇦🇼 +297' },
  { value: '+298-FO', label: '🇫🇴 +298' },
  { value: '+299-GL', label: '🇬🇱 +299' },
  { value: '+30-GR', label: '🇬🇷 +30' },
  { value: '+31-NL', label: '🇳🇱 +31' },
  { value: '+32-BE', label: '🇧🇪 +32' },
  { value: '+33-FR', label: '🇫🇷 +33' },
  { value: '+34-ES', label: '🇪🇸 +34' },
  { value: '+350-GI', label: '🇬🇮 +350' },
  { value: '+351-PT', label: '🇵🇹 +351' },
  { value: '+352-LU', label: '🇱🇺 +352' },
  { value: '+353-IE', label: '🇮🇪 +353' },
  { value: '+354-IS', label: '🇮🇸 +354' },
  { value: '+355-AL', label: '🇦🇱 +355' },
  { value: '+356-MT', label: '🇲🇹 +356' },
  { value: '+357-CY', label: '🇨🇾 +357' },
  { value: '+358-AX', label: '🇦🇽 +358' },
  { value: '+358-FI', label: '🇫🇮 +358' },
  { value: '+359-BG', label: '🇧🇬 +359' },
  { value: '+36-HU', label: '🇭🇺 +36' },
  { value: '+370-LT', label: '🇱🇹 +370' },
  { value: '+371-LV', label: '🇱🇻 +371' },
  { value: '+372-EE', label: '🇪🇪 +372' },
  { value: '+373-MD', label: '🇲🇩 +373' },
  { value: '+374-AM', label: '🇦🇲 +374' },
  { value: '+375-BY', label: '🇧🇾 +375' },
  { value: '+376-AD', label: '🇦🇩 +376' },
  { value: '+377-MC', label: '🇲🇨 +377' },
  { value: '+378-SM', label: '🇸🇲 +378' },
  { value: '+380-UA', label: '🇺🇦 +380' },
  { value: '+381-RS', label: '🇷🇸 +381' },
  { value: '+382-ME', label: '🇲🇪 +382' },
  { value: '+385-HR', label: '🇭🇷 +385' },
  { value: '+386-SI', label: '🇸🇮 +386' },
  { value: '+387-BA', label: '🇧🇦 +387' },
  { value: '+389-MK', label: '🇲🇰 +389' },
  { value: '+39-IT', label: '🇮🇹 +39' },
  { value: '+39-VA', label: '🇻🇦 +39' },
  { value: '+40-RO', label: '🇷🇴 +40' },
  { value: '+41-CH', label: '🇨🇭 +41' },
  { value: '+420-CZ', label: '🇨🇿 +420' },
  { value: '+421-SK', label: '🇸🇰 +421' },
  { value: '+423-LI', label: '🇱🇮 +423' },
  { value: '+43-AT', label: '🇦🇹 +43' },
  { value: '+44-GB', label: '🇬🇧 +44' },
  { value: '+44-GG', label: '🇬🇬 +44' },
  { value: '+44-IM', label: '🇮🇲 +44' },
  { value: '+44-JE', label: '🇯🇪 +44' },
  { value: '+45-DK', label: '🇩🇰 +45' },
  { value: '+46-SE', label: '🇸🇪 +46' },
  { value: '+47-NO', label: '🇳🇴 +47' },
  { value: '+47-SJ', label: '🇸🇯 +47' },
  { value: '+48-PL', label: '🇵🇱 +48' },
  { value: '+49-DE', label: '🇩🇪 +49' },
  { value: '+500-FK', label: '🇫🇰 +500' },
  { value: '+500-GS', label: '🇬🇸 +500' },
  { value: '+501-BZ', label: '🇧🇿 +501' },
  { value: '+502-GT', label: '🇬🇹 +502' },
  { value: '+503-SV', label: '🇸🇻 +503' },
  { value: '+504-HN', label: '🇭🇳 +504' },
  { value: '+505-NI', label: '🇳🇮 +505' },
  { value: '+506-CR', label: '🇨🇷 +506' },
  { value: '+507-PA', label: '🇵🇦 +507' },
  { value: '+508-PM', label: '🇵🇲 +508' },
  { value: '+509-HT', label: '🇭🇹 +509' },
  { value: '+51-PE', label: '🇵🇪 +51' },
  { value: '+52-MX', label: '🇲🇽 +52' },
  { value: '+53-CU', label: '🇨🇺 +53' },
  { value: '+54-AR', label: '🇦🇷 +54' },
  { value: '+55-BR', label: '🇧🇷 +55' },
  { value: '+56-CL', label: '🇨🇱 +56' },
  { value: '+57-CO', label: '🇨🇴 +57' },
  { value: '+58-VE', label: '🇻🇪 +58' },
  { value: '+590-BL', label: '🇧🇱 +590' },
  { value: '+590-GP', label: '🇬🇵 +590' },
  { value: '+590-MF', label: '🇲🇫 +590' },
  { value: '+591-BO', label: '🇧🇴 +591' },
  { value: '+592-GY', label: '🇬🇾 +592' },
  { value: '+593-EC', label: '🇪🇨 +593' },
  { value: '+594-GF', label: '🇬🇫 +594' },
  { value: '+595-PY', label: '🇵🇾 +595' },
  { value: '+596-MQ', label: '🇲🇶 +596' },
  { value: '+597-SR', label: '🇸🇷 +597' },
  { value: '+598-UY', label: '🇺🇾 +598' },
  { value: '+599-BQ', label: '🇧🇶 +599' },
  { value: '+599-CW', label: '🇨🇼 +599' },
  { value: '+60-MY', label: '🇲🇾 +60' },
  { value: '+61-AU', label: '🇦🇺 +61' },
  { value: '+61-CC', label: '🇨🇨 +61' },
  { value: '+61-CX', label: '🇨🇽 +61' },
  { value: '+62-ID', label: '🇮🇩 +62' },
  { value: '+63-PH', label: '🇵🇭 +63' },
  { value: '+64-NZ', label: '🇳🇿 +64' },
  { value: '+64-PN', label: '🇵🇳 +64' },
  { value: '+65-SG', label: '🇸🇬 +65' },
  { value: '+66-TH', label: '🇹🇭 +66' },
  { value: '+670-TL', label: '🇹🇱 +670' },
  { value: '+672-NF', label: '🇳🇫 +672' },
  { value: '+673-BN', label: '🇧🇳 +673' },
  { value: '+674-NR', label: '🇳🇷 +674' },
  { value: '+675-PG', label: '🇵🇬 +675' },
  { value: '+676-TO', label: '🇹🇴 +676' },
  { value: '+677-SB', label: '🇸🇧 +677' },
  { value: '+678-VU', label: '🇻🇺 +678' },
  { value: '+679-FJ', label: '🇫🇯 +679' },
  { value: '+680-PW', label: '🇵🇼 +680' },
  { value: '+681-WF', label: '🇼🇫 +681' },
  { value: '+682-CK', label: '🇨🇰 +682' },
  { value: '+683-NU', label: '🇳🇺 +683' },
  { value: '+685-WS', label: '🇼🇸 +685' },
  { value: '+686-KI', label: '🇰🇮 +686' },
  { value: '+687-NC', label: '🇳🇨 +687' },
  { value: '+688-TV', label: '🇹🇻 +688' },
  { value: '+689-PF', label: '🇵🇫 +689' },
  { value: '+690-TK', label: '🇹🇰 +690' },
  { value: '+691-FM', label: '🇫🇲 +691' },
  { value: '+692-MH', label: '🇲🇭 +692' },
  { value: '+7-KZ', label: '🇰🇿 +7' },
  { value: '+7-RU', label: '🇷🇺 +7' },
  { value: '+81-JP', label: '🇯🇵 +81' },
  { value: '+82-KR', label: '🇰🇷 +82' },
  { value: '+84-VN', label: '🇻🇳 +84' },
  { value: '+850-KP', label: '🇰🇵 +850' },
  { value: '+852-HK', label: '🇭🇰 +852' },
  { value: '+853-MO', label: '🇲🇴 +853' },
  { value: '+855-KH', label: '🇰🇭 +855' },
  { value: '+856-LA', label: '🇱🇦 +856' },
  { value: '+86-CN', label: '🇨🇳 +86' },
  { value: '+880-BD', label: '🇧🇩 +880' },
  { value: '+886-TW', label: '🇹🇼 +886' },
  { value: '+90-TR', label: '🇹🇷 +90' },
  { value: '+91-IN', label: '🇮🇳 +91' },
  { value: '+92-PK', label: '🇵🇰 +92' },
  { value: '+93-AF', label: '🇦🇫 +93' },
  { value: '+94-LK', label: '🇱🇰 +94' },
  { value: '+95-MM', label: '🇲🇲 +95' },
  { value: '+960-MV', label: '🇲🇻 +960' },
  { value: '+961-LB', label: '🇱🇧 +961' },
  { value: '+962-JO', label: '🇯🇴 +962' },
  { value: '+963-SY', label: '🇸🇾 +963' },
  { value: '+964-IQ', label: '🇮🇶 +964' },
  { value: '+965-KW', label: '🇰🇼 +965' },
  { value: '+966-SA', label: '🇸🇦 +966' },
  { value: '+967-YE', label: '🇾🇪 +967' },
  { value: '+968-OM', label: '🇴🇲 +968' },
  { value: '+970-PS', label: '🇵🇸 +970' },
  { value: '+971-AE', label: '🇦🇪 +971' },
  { value: '+972-IL', label: '🇮🇱 +972' },
  { value: '+973-BH', label: '🇧🇭 +973' },
  { value: '+974-QA', label: '🇶🇦 +974' },
  { value: '+975-BT', label: '🇧🇹 +975' },
  { value: '+976-MN', label: '🇲🇳 +976' },
  { value: '+977-NP', label: '🇳🇵 +977' },
  { value: '+98-IR', label: '🇮🇷 +98' },
  { value: '+992-TJ', label: '🇹🇯 +992' },
  { value: '+993-TM', label: '🇹🇲 +993' },
  { value: '+994-AZ', label: '🇦🇿 +994' },
  { value: '+995-GE', label: '🇬🇪 +995' },
  { value: '+996-KG', label: '🇰🇬 +996' },
  { value: '+998-UZ', label: '🇺🇿 +998' },
];
